import { RawLink } from '@/shared/ui/RawLink'
import { homePagePath } from '@/shared/constants/homeConstants'
import { Box } from '@mui/material'
import React from 'react'
import useAppSkin from '../hooks/useAppSkin'
import {
    useAppStore,
    useTVStore,
    useVisibilityStore,
    useVODStore,
} from '../store'
import packageJson from '../../../package.json'

const Logo = () => {
    const { setHomeContentVisible } = useVisibilityStore()
    const { appMenuLogo } = useAppSkin()

    const { setClearVod } = useVODStore()

    const { setWhatNextId } = useTVStore()

    const { setAssetType } = useAppStore()

    const resetVodState = () => {
        setAssetType(null)
        setClearVod()
        setWhatNextId('')
    }

    const handleClick = () => {
        setHomeContentVisible()
        resetVodState()
    }

    const { appVersion } = packageJson
    const logoStyle = {
        width: 'max-content',
        mr: { xs: '16px', sm: '40px' },
        mt: '7px',
        '& > svg, img': {
            minWidth: '90px',
            maxWidth: '150px',
            width: '100%',
            height: 'auto',
        },
        '&:hover': {
            cursor: 'pointer',
        },
    }

    return (
        <RawLink to={homePagePath}>
            <Box onClick={handleClick} sx={logoStyle}>
                <img src={appMenuLogo} alt="TOYA GO" />
            </Box>
        </RawLink>
    )
}

export { Logo }
